import { render, staticRenderFns } from "./Stakeholder.vue?vue&type=template&id=c5ebeeee"
import script from "./Stakeholder.vue?vue&type=script&lang=js"
export * from "./Stakeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5ebeeee')) {
      api.createRecord('c5ebeeee', component.options)
    } else {
      api.reload('c5ebeeee', component.options)
    }
    module.hot.accept("./Stakeholder.vue?vue&type=template&id=c5ebeeee", function () {
      api.rerender('c5ebeeee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/view/Stakeholder.vue"
export default component.exports